'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.togglePopup = exports.closePopup = exports.openPopup = undefined;

var _popupConstants = require('./popupConstants');

var openPopup = exports.openPopup = function openPopup(popupId) {
    return {
        type: _popupConstants.POPUP_OPEN,
        popupId: popupId
    };
};

var closePopup = exports.closePopup = function closePopup(popupId) {
    var closeAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return {
        type: _popupConstants.POPUP_CLOSE,
        popupId: popupId,
        closeAll: closeAll
    };
};

var togglePopup = exports.togglePopup = function togglePopup(popupId) {
    return {
        type: _popupConstants.POPUP_TOGGLE,
        popupId: popupId
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/popupActions.js
// module id = 35
// module chunks = 0